module.exports = __webpack_public_path__ + "static/63-5c08f163026f8476dac7e3aae7f83a8a.png";